import { render, staticRenderFns } from "./tabObjectWorks.vue?vue&type=template&id=2d957bd2&"
import script from "./tabObjectWorks.vue?vue&type=script&lang=js&"
export * from "./tabObjectWorks.vue?vue&type=script&lang=js&"
import style0 from "./tabObjectWorks.vue?vue&type=style&index=0&id=2d957bd2&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports